import React from "react";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { CircularProgress, Fab, Paper } from "@mui/material";
import ReactPlayer from "react-player";
import { makeStyles } from "tss-react/mui";

import { ChatMessageAttachmentFragment } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

import DownloadIcon from "../../../../components/Icons/DownloadIcon";
import If from "../../../../components/layout/If";
import Margin from "../../../../components/layout/Margin";

interface Props {
  attachment: ChatMessageAttachmentFragment;
  isUploaded: boolean;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    position: "relative",
    borderRadius: theme.spacing(2),
    backgroundColor: "#F7F9FB",
    overflow: "hidden",
  },
  downloadPosition: {
    position: "absolute",
    top: 0,
    right: 0,
  },
  download: {
    width: 38,
    height: 38,
    fontSize: 17,
    boxShadow: "none",
    "&:active": {
      boxShadow: "none",
    },
  },
  progress: {
    width: "38px !important",
    height: "38px !important",
  },
  play: {
    color: colors.white,
    backgroundColor: "rgba(255,255,255,0.5)",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.64)",
    },
  },
}));

const AttachmentVideo: React.FC<Props> = ({ attachment, isUploaded }) => {
  const { classes } = useStyles();

  return (
    <Paper className={classes.root} elevation={0}>
      <ReactPlayer
        url={attachment.url}
        light={attachment.cloudinaryPreview ?? undefined}
        playIcon={
          <Fab className={classes.play}>
            <PlayArrowIcon />
          </Fab>
        }
        playing
        controls
        playsinline
      />
      <div className={classes.downloadPosition}>
        <Margin all="7px">
          <If
            condition={isUploaded}
            then={
              <Fab
                className={classes.download}
                color="primary"
                aria-label="download"
                component="a"
                href={attachment.downloadUrl}
                download={attachment.filename}
                target="_blank"
              >
                <DownloadIcon fontSize="inherit" />
              </Fab>
            }
            else={<CircularProgress className={classes.progress} />}
          />
        </Margin>
      </div>
    </Paper>
  );
};

export default AttachmentVideo;
